import { ApiError } from 'types/ApiError';
import { PostingsService } from '../services';
import { BulkReviewPostingProps } from 'types/Posting';
import { useMutation } from '@tanstack/react-query';

export type { BulkReviewPostingProps } from 'types/Posting';

export interface CancelPostingProps {
	postingId: string;
}

export const usePostings = (options?: {
	onError?: (error: ApiError) => void;
	onCreateSuccess?: () => void;
	onReviewSuccess?: () => void;
}) => {
	const { mutate: bulkReviewPostingMutate, isPending: isUpdating } =
		useMutation<void, ApiError, BulkReviewPostingProps>({
			mutationFn: variables =>
				PostingsService.bulkReviewPosting(
					variables.items,
					variables.mfaToken,
				),
			onSuccess: () => {
				if (typeof options?.onReviewSuccess === 'function') {
					options.onReviewSuccess();
				}
			},
			onError: e => {
				if (typeof options?.onError === 'function') {
					options.onError(e);
				}
			},
		});

	const { mutate: cancelPostingMutate, isPending: isCanceling } = useMutation<
		void,
		ApiError,
		CancelPostingProps
	>({
		mutationFn: variables => {
			return PostingsService.cancelPosting(variables.postingId);
		},
		onSuccess: () => {
			if (typeof options?.onCreateSuccess === 'function') {
				options.onCreateSuccess();
			}
		},
		onError: e => {
			if (typeof options?.onError === 'function') {
				options.onError(e);
			}
		},
	});

	const bulkReviewPosting = (props: BulkReviewPostingProps) => {
		bulkReviewPostingMutate(props);
	};

	const cancelPosting = ({ postingId }: CancelPostingProps) => {
		cancelPostingMutate({ postingId });
	};

	return {
		cancelPosting,
		bulkReviewPosting,
		isUpdating,
		isCanceling,
	};
};
